import React, { useState, useEffect } from "react";
import Header1 from "../../../components/header1/Header1";
import Footer from "../../../components/footer/Footer";

const AdminCourseControl = () => {
  const [learningTracks, setLearningTracks] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [newCourse, setNewCourse] = useState({
    courseName: "",
    courseLink: "",
    paid: false,
  });
  const [editingCourse, setEditingCourse] = useState(null);
  const [showAddCourseForm, setShowAddCourseForm] = useState({});
  const [currentTrack, setCurrentTrack] = useState(null);

  // Fetch data from the backend API
  useEffect(() => {
    const fetchLearningTracks = async () => {
      try {
        const response = await fetch("{http://localhost:8090}/api/learning-tracks",{credentials: 'include',});
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const tracks = await response.json();
        setLearningTracks(tracks);
        if (tracks.length > 0) {
          setActiveTab(tracks[0].trackName); // Set the first track as the active tab
        }
      } catch (error) {
        console.error("Error fetching learning tracks:", error);
      }
    };

    fetchLearningTracks();
  }, []);

  // Handle tab switching
  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  // Get courses for the active track
  const activeCourses =
    learningTracks.find((track) => track.trackName === activeTab)?.courses || [];

  // Handle new course input
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewCourse({
      ...newCourse,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Add or Edit course
  const handleSaveCourse = () => {
    if (editingCourse) {
      // Update the course
      const updatedCourses = learningTracks.map((track) => {
        if (track.trackName === activeTab) {
          const updatedCoursesList = track.courses.map((course) =>
            course.courseId === editingCourse.courseId
              ? { ...course, ...newCourse }
              : course
          );
          return { ...track, courses: updatedCoursesList };
        }
        return track;
      });
      setLearningTracks(updatedCourses);
      setEditingCourse(null); // Reset editing mode
    } else {
      // Add new course to active track
      const updatedTracks = learningTracks.map((track) => {
        if (track.trackName === currentTrack) {
          const newCourseWithId = {
            ...newCourse,
            courseId: new Date().getTime(), // Temporary ID for new course
          };
          return { ...track, courses: [...track.courses, newCourseWithId] };
        }
        return track;
      });
      setLearningTracks(updatedTracks);
    }
    setNewCourse({ courseName: "", courseLink: "", paid: false }); // Reset form
    setShowAddCourseForm((prev) => ({ ...prev, [currentTrack]: false })); // Close the form
  };

  // Edit a course
  const handleEditCourse = (course) => {
    setNewCourse({ courseName: course.courseName, courseLink: course.courseLink, paid: course.paid });
    setEditingCourse(course);
  };


    // Delete a course
    const handleDeleteCourse = (courseId) => {
      const updatedTracks = learningTracks.map((track) => {
        if (track.trackName === activeTab) {
          const updatedCourses = track.courses.filter(
            (course) => course.courseId !== courseId
          );
          return { ...track, courses: updatedCourses };
        }
        return track;
      });
      setLearningTracks(updatedTracks);
    };

  // Toggle form visibility
  const toggleAddCourseForm = (trackName) => {
    setShowAddCourseForm((prev) => ({
      ...prev,
      [trackName]: !prev[trackName], // Toggle the visibility of the form for the specific track
    }));
    setCurrentTrack(trackName); // Set the current track to add courses to it
  };

  return (
    <div className="md:mx-20">
      <Header1 />
      <hr/>
      {/* Tabs */}
      <div className="relative w-full">
        <h1 className="text-4xl my-8 text-center font-semibold text-gray-800">
          SELECT LEARNING TRACK
        </h1>

        {/* Tabs */}
        <div className="flex justify-center space-x-6 mb-8">
          {learningTracks.map((track) => (
            <button
              key={track.trackId}
              onClick={() => handleTabChange(track.trackName)}
              className={`px-6 py-3 text-lg font-medium text-white rounded-lg transition-all duration-300 ${
                activeTab === track.trackName
                  ? "bg-blue-600 shadow-lg transform scale-105"
                  : "bg-gray-400 hover:bg-blue-500"
              }`}
            >
              {track.trackName}
            </button>
          ))}
        </div>

        {/* Form to add course for specific track */}
        {showAddCourseForm[activeTab] && (
          <div className="mb-6 p-6 bg-white rounded-lg shadow-md">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              {editingCourse ? "Edit Course" : "Add New Course"}
            </h3>
            <form>
              <div className="mb-4">
                <label htmlFor="courseName" className="block text-gray-600 mb-2">
                  Course Name
                </label>
                <input
                  type="text"
                  id="courseName"
                  name="courseName"
                  value={newCourse.courseName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  placeholder="Enter course name"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="courseLink" className="block text-gray-600 mb-2">
                  Course Link
                </label>
                <input
                  type="text"
                  id="courseLink"
                  name="courseLink"
                  value={newCourse.courseLink}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  placeholder="Enter course link"
                />
              </div>
              <div className="mb-4">
                <label className="inline-flex items-center text-gray-600">
                  <input
                    type="checkbox"
                    name="paid"
                    checked={newCourse.paid}
                    onChange={handleInputChange}
                    className="form-checkbox text-blue-600"
                  />
                  <span className="ml-2">Paid Course</span>
                </label>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={handleSaveCourse}
                  className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
                >
                  {editingCourse ? "Save Changes" : "Add Course"}
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Courses for Active Tab */}
        <div className="p-6">
          {learningTracks.map(
            (track) =>
              activeTab === track.trackName && (
                <div key={track.trackId}>
                  <h2 className="text-2xl font-bold text-gray-800 mb-6">
                    {track.trackName} Courses
                  </h2>
                  <div className="flex justify-between mb-4">
                    <button
                      onClick={() => toggleAddCourseForm(track.trackName)}
                      className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
                    >
                      {showAddCourseForm[track.trackName] ? "Cancel" : "Add New Course"}
                    </button>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {track.courses.map((course) => (
                      <div
                        key={course.courseId}
                        className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 ease-in-out p-6 flex flex-col"
                      >
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">
                          {course.courseName}
                        </h3>
                        <p className="text-gray-600 mb-4">
                          {course.paid ? "Paid" : "Free"} Course
                        </p>
                        <a
                          href={course.courseLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mt-auto text-center bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition duration-200"
                        >
                          Learn More
                        </a>
                        <button
                          onClick={() => handleEditCourse(course)}
                          className="mt-2 text-white text-blue-600 hover:underline rounded-md"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDeleteCourse(course.courseId)}
                          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                        >
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )
          )}
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default AdminCourseControl;